module.exports = __webpack_public_path__ + "img/media_12.c61db519.jpg";